import styled from 'styled-components'
import {
    themeColor,
} from '@elparking/components'

const display = ({isMarked}) => isMarked ? 'block' : 'none'
const opacity = ({isMarked}) => isMarked ? '0.3' : '1'

export default styled.div`
    background: ${themeColor('white')};
    width: 100%;
    height: 100%;
    position: relative;

    &:after {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: ${display};
        content: ' ';
        position: absolute;
        opacity: ${opacity};
        background: ${themeColor('black')};
    }
`
